

class TransactionService {

    constructor(axios, baseUrl) {
        this.axios = axios;
        this.baseUrl = `${baseUrl}/transactions`;

    }

    getAll(token) {
        this.user = { params: { token } };
        let self = this;
        return self.axios.get(self.baseUrl, self.user)

    }

    getOne(id, token) {
        let self = this;
        this.user = { params: { token } };
        return self.axios.get(`${self.baseUrl}/${id}`, self.user)
    }

    sendEmailRequest(transactionId, merchanId, token){
        let self = this;
        let data = Object.assign({}, {merchan_id:merchanId, transaction_id:transactionId, token, urlFrom: window.location.origin })
        return self.axios.post( `${self.baseUrl}/request`, data )
    }
   

}
export default TransactionService


// WEBPACK FOOTER //
// ./src/services/transactionService.js